import InputType from "common/form/InputType";
import { Form, Input } from "decorator-form";
import { BlockStylesConfig, blockStylesInput } from "../../../common/views/common/BlockStylesConfig";

@Form({title: "Container View Config"})
export default class Config {

	@Input({type: InputType.UNIT, title: "Max Width"})
	public maxWidth: string;

	@Input({type: blockStylesInput, title: "Block Style"})
	public blockStyles?: BlockStylesConfig;
}



// WEBPACK FOOTER //
// ./src/panels/container/view/ContainerViewConfig.ts